import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Parametro } from '../service-base/parametro';
import { ServiceBase } from '../service-base/ServiceBase';
import { AuthGuard } from './../../security/guards/auth-guard/auth.guard';

@Injectable()
export abstract class ServiceCRUD extends ServiceBase {
    length: number;


    constructor(http: HttpClient, router: Router) {
        super(http, router);
    }

    public salvar(obj: any): Promise<any> {
        if (obj.id) {
            return this.atualizar(obj, []);
        } else {
            obj.id = 0;
            return this.incluir(obj, []);
        }
    }

    public excluir(id: number): Promise<any> {
        const parametros: Parametro[] = [];
        parametros.push(new Parametro('id', id.toString()));
        return this.remover(parametros);
    }

    public buscar(filtros: object): Promise<any> {
        return this.listar([], filtros);
    }

    public buscarGet(filtros: object): Promise<any> {
        return this.getComQueryParams(filtros);
    }

    getDealerCode(): string {
        return new AuthGuard(this.router).getToken();
    }
}
